import * as React from "react";
const SVGComponentFooterEvents = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth={0} />
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g id="SVGRepo_iconCarrier">
      <path
        d="M4 10V13"
        stroke="#222b63"
        strokeWidth={1.7}
        strokeLinecap="round"
      />
      <path
        d="M16 10V13"
        stroke="#222b63"
        strokeWidth={1.7}
        strokeLinecap="round"
      />
      <path
        d="M7 7L7 16"
        stroke="#785af0"
        strokeWidth={1.7}
        strokeLinecap="round"
      />
      <path
        d="M13 7L13 16"
        stroke="#222b63"
        strokeWidth={1.7}
        strokeLinecap="round"
      />
      <path
        d="M19 7L19 16"
        stroke="#222b63"
        strokeWidth={1.7}
        strokeLinecap="round"
      />
      <path
        d="M10 4L10 19"
        stroke="#222b63"
        strokeWidth={1.7}
        strokeLinecap="round"
      />
    </g>
  </svg>
);
export default SVGComponentFooterEvents;
